import { render, staticRenderFns } from "./StoreDomainCustomDomain.vue?vue&type=template&id=e36ab34c&"
import script from "./StoreDomainCustomDomain.vue?vue&type=script&lang=ts&"
export * from "./StoreDomainCustomDomain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports